import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../Utils/renderField/renderReadField";
import { IngresosBodegaApi } from "../api/IngresosBodegaApi";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";

export const MetricasEstado = (props) => {
    const {
        filtros,
        textoMetricas,
        refreshMetricasKey,
        recibidoBodegaMetricas,
    } = props;

    const { getMetricasEstado, cargando } = IngresosBodegaApi();

    const [metricas, setMetricas] = useState({});

    const GetMetricasEstado = async () => {
        try {
            const params = {
                ...filtros,
                recibido_bodega: recibidoBodegaMetricas,
            };

            const response = await getMetricasEstado(params);
            setMetricas(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las métricas por estado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setMetricas({});
        }
    };

    // filtros es un objeto nuevo en cada render, por lo que la recarga se
    // dispara con refreshMetricasKey, que ya se incrementa al cambiar filtros
    useEffect(() => {
        GetMetricasEstado();
    }, [refreshMetricasKey]);

    return (
        <React.Fragment>
            <div
                className="d-flex justify-content-between gap-2rem flex-wrap py-3 px-3 mt-3 mb-3"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <div className="flex-grow-1 d-flex align-items-center">
                    <h4 className="mb-0">{textoMetricas}</h4>
                </div>
                <div className="d-flex align-items-center gap-2rem flex-wrap">
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Total de pallets
                        </label>
                        <h4 className="text-nowrap">
                            <RenderNumber
                                value={metricas.total_pallets || 0}
                                decimals={0}
                            />
                        </h4>
                    </div>
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Kg hule seco
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={metricas.total_peso || 0}
                                decimals={3}
                            />
                        </h4>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
